import * as Switch from '@radix-ui/react-switch';
import styled from 'styled-components';
export const Root = styled(Switch.Root) `
	position: relative;

	background-color: var(--surface-white);
	border: 1px solid var(--border-active);
	border-radius: 999px;

	width: 48px;
	height: 24px;

	cursor: pointer;

	&[data-state='checked'] {
		background-color: var(--surface-accent-dark);
	}

	&:disabled {
		border: 1px solid var(--border-primary);

		background-color: var(--border-primary);

		span {
			background-color: var(--surface-white);
		}
	}
`;
export const Thumb = styled(Switch.Thumb) `
	display: block;

	background-color: var(--surface-accent-dark);
	border-radius: 999px;

	width: 16px;
	height: 16px;

	transform: translateX(-2px);
	transition: all 100ms;

	&[data-state='checked'] {
		background-color: var(--surface-white);

		transform: translateX(20px);
	}
`;
//# sourceMappingURL=styles.js.map